export var DocsBlockTextPropertyStyle;
(function (DocsBlockTextPropertyStyle) {
    /** Title type 1, roughly equivalent of h2 in size */
    DocsBlockTextPropertyStyle["title1"] = "Title1";
    /** Title type 2, roughly equivalent of h3 in size */
    DocsBlockTextPropertyStyle["title2"] = "Title2";
    /** Title type 3, roughly equivalent of h4 in size */
    DocsBlockTextPropertyStyle["title3"] = "Title3";
    /** Title type 4, roughly equivalent of h5 in size */
    DocsBlockTextPropertyStyle["title4"] = "Title4";
    /** Title type 5, roughly equivalent of h6 in size */
    DocsBlockTextPropertyStyle["title5"] = "Title5";
    /** Default text, equals regular */
    DocsBlockTextPropertyStyle["default"] = "Default";
    /** Bold text */
    DocsBlockTextPropertyStyle["defaultBold"] = "DefaultBold";
    /** Semibold text */
    DocsBlockTextPropertyStyle["defaultSemibold"] = "DefaultSemibold";
    /** Small text */
    DocsBlockTextPropertyStyle["small"] = "Small";
    /** Small bold text */
    DocsBlockTextPropertyStyle["smallBold"] = "SmallBold";
    /** Small semibold text */
    DocsBlockTextPropertyStyle["smallSemibold"] = "SmallSemibold";
    /** Custom (will render as text field) */
    DocsBlockTextPropertyStyle["custom"] = "Custom";
})(DocsBlockTextPropertyStyle || (DocsBlockTextPropertyStyle = {}));
